import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons'; // Close icon

const ConfirmCheckoutModal = ({ isOpen, onClose, onCheckout }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
      <div className="relative bg-white rounded-lg shadow-2xl w-[90%] max-w-sm p-6">
        {/* Close Icon */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 focus:outline-none"
          aria-label="Close"
        >
          <FontAwesomeIcon icon={faTimes} className="w-4 h-4" />
        </button>

        {/* Modal Text */}
        <p className="text-base text-gray-800 text-center mb-6 font-semibold">
          Are you sure you want to checkout?
        </p>

        {/* Buttons */}
        <div className="flex justify-center gap-4">
          <button
            onClick={onClose}
            className="px-5 py-2 text-sm border border-gray-300 text-gray-700 rounded-md hover:bg-gray-100 transition"
          >
            Cancel
          </button>
          <button
            onClick={onCheckout}
            className="px-5 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
          >
            Checkout
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmCheckoutModal;
